"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("../../constants");
const btcstakingtx = __importStar(require("../../generated/babylon/btcstaking/v1/tx"));
const incentivetx = __importStar(require("../../generated/babylon/incentive/tx"));
const createClaimRewardMsg = ({ address }) => {
    const withdrawRewardMsg = incentivetx.MsgWithdrawReward.fromPartial({
        type: constants_1.BTC_STAKER,
        address,
    });
    return {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgWithdrawRewardForBTCStaking,
        value: withdrawRewardMsg,
    };
};
//TODO: modify input params to accept tx hashes instead of raw bin format (Uint8Array -> string)
/**
 * Creates a BTC stake expansion message
 * @param params - The parameters for the stake expansion
 * @returns The BTC stake expansion message
 */
const createExpandMsg = (params) => {
    const stakeExpandMsg = btcstakingtx.MsgBtcStakeExpand.fromPartial(params);
    return {
        typeUrl: constants_1.REGISTRY_TYPE_URLS.MsgBtcStakeExpand,
        value: stakeExpandMsg,
    };
};
exports.default = {
    createClaimRewardMsg,
    createExpandMsg,
};
//# sourceMappingURL=btc.js.map